'use client';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { ProjectSettingsModeGroupEnum } from '@/app/api';
import Button, { ButtonHTMLTag, ButtonStyle } from '@/app/components/Button/Button';

export const DonateButton = ({
  donationLink,
  onCommercialDonationClick,
  projectModeGroup,
}: {
  donationLink: string;
  projectModeGroup: ProjectSettingsModeGroupEnum;
  onCommercialDonationClick?: () => void;
}) => {
  const { t } = useTranslation();

  if (projectModeGroup === ProjectSettingsModeGroupEnum.Plus) {
    return (
      <Button
        style={ButtonStyle.PRIMARY}
        className={classNames('hidden lg:block w-[360px] text-center px-[24px] py-[20px]')}
        tagSpecificProps={{ htmlTag: ButtonHTMLTag.BUTTON, onClick: onCommercialDonationClick }}
      >
        {t('components.DonateBox.donateCommercial')}
      </Button>
    );
  }
  return (
    <Button
      style={ButtonStyle.PRIMARY}
      className={classNames('hidden lg:block w-[360px] text-center px-[24px] py-[20px]')}
      tagSpecificProps={{ htmlTag: ButtonHTMLTag.LINK, href: donationLink }}
    >
      {t('pages.collection.donate')}
    </Button>
  );
};
